import { AddressComponentType } from '@/types/places';

export const COMPONENT_TYPES = Object.values(AddressComponentType);

export const ADDRESS_PARTS = [
  'line1',
  'line2',
  'town',
  'city',
  'state',
  'zip',
  'country',
];
export const ADDRESS_PART_ORDER: Record<string, number> = {
  line1: 0,
  line2: 1,
  town: 2,
  city: 3,
  state: 4,
  zip: 5,
  country: 6,
};

export const ADDRESS_MAX_LENGTH = {
  line1: 40,
  city: 40,
  state: 40,
  zip: 10,
  poBox: 10,
  poBoxDistrict: 40,
};

export const EMPLOYER_MAX_LENGTH = {
  employerName: 40,
  employerAddress: 40,
};

export const FUNDING_SOURCE_MAX_LENGTH = {
  otherFundingSource: 40,
};
